export default __webpack_public_path__ + "static/media/Step5-cto.98ef2d1e.svg";